export default "__VITE_ASSET__DL3H5B7q__"